import React from 'react';
import './Worldmap.css'

const Worldmap = () => {
    return (
        <div className='container' >
            <div className=" my-5 " >
               <h1 className='fw-bold' > Explore the World <span className='t-color' > For Yourself </span> </h1>
            </div>
            <img className='img-fluid' src='https://roam.qodeinteractive.com/wp-content/uploads/2017/08/h1-img-1.png' alt="" />
        </div>
    );
};

export default Worldmap;